// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.util.VersionInfoHelper
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { AbSemanticVersionNumber } from "abweb/dto/generated/com/abinitio/sdk/commons/api/dto/AbSemanticVersionNumber";
import { AbVersionInfo } from "abweb/dto/generated/com/abinitio/sdk/commons/api/dto/AbVersionInfo";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class VersionInfoHelperBase extends AbVersionInfo {
  /** Do NOT invoke directly, instead use strongly typed createVersionInfoHelperBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawau.VersionInfoHelper";
  }
  initFromJson(json, deserializeContext) {
    this.initVersionInfoHelper(json.compatibility != null ? json.compatibility : null, TSOGUtils.decodeObject(json.semanticVersionNumber, AbSemanticVersionNumber, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "semanticVersionNumber")), json.versionNumber != null ? json.versionNumber : null);
  }
  initVersionInfoHelper(compatibility, semanticVersionNumber, versionNumber) {
    this.initAbVersionInfo(compatibility, semanticVersionNumber, versionNumber);
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    return retVal;
  }
}
//# sourceMappingURL=VersionInfoHelperBase.js.map
